import { render, staticRenderFns } from "./RelatedDevice.vue?vue&type=template&id=aa423980&scoped=true&"
import script from "./RelatedDevice.vue?vue&type=script&lang=js&"
export * from "./RelatedDevice.vue?vue&type=script&lang=js&"
import style0 from "./RelatedDevice.vue?vue&type=style&index=0&id=aa423980&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa423980",
  null
  
)

export default component.exports